module.exports = __webpack_public_path__ + "static/img/bouncemangopassionfruit_th.d1de526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/bouncemangopassionfruit_th.png
// module id = VuuK
// module chunks = 0